import { useMutation } from 'react-query';
import { useActions } from '../../../../context/Actions.context';
import Endpoints from '../../../constants/endpoints';
import { useServices } from '../../../services/useServices';
import { IGetBookListParams } from '../book.dto';

export const useMuteAuthor = (name) => {
  const {
    book: { muteAuthor }
  } = useServices();

  const { source: sourcePath } = useActions();
  const sourceTab = window.location.pathname.split('/')[2];

  return useMutation(
    'mute-author',
    (param: IGetBookListParams) =>
      muteAuthor(
        {
          source: sourcePath['source'],
          sourceTab,
          endpoint: Endpoints[name],
          action: name
        },
        param
      )
  );
};